// export const apiUrl = "http://37.193.182.4:8089/api/";
export const apiUrl = "https://charsheet-api.duckdns.org/api/";
export const tokenRefreshBefore = 60 * 30 * 1000; // 30min
